import { Map } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
export const actions = {
    REQUEST: createAction('CREATE/PREFERENCES/REQUEST'),
    SUCCESS: createAction('CREATE/PREFERENCES/SUCCESS'),
    ERROR: createAction('CREATE/PREFERENCES/ERROR'),
};
const initialState = Map({
    data: null,
    isProcessing: false,
    error: null,
});
const reducer = handleActions({
    [actions.REQUEST]: (state) => state.set('isProcessing', true),
    [actions.SUCCESS]: (state, action) => state.set('isProcessing', false).set('data', action.payload),
    [actions.ERROR]: (state, action) => state.set('isProcessing', false).set('error', action.payload),
}, initialState);
export default reducer;
